import React from 'react';
import classnames from 'classnames';
import { Icon } from '@sm/wds-react';
import { useTheme } from 'react-jss';
import { WrenchTheme } from '@wds/styles';

import { LogoProps } from './typings';
import useStyles from './useStyles';

const Logo = ({ color = 'primary', className = '', ...other }: LogoProps) => {
  const theme: typeof WrenchTheme = useTheme();

  const { logo } = useStyles({ color, theme });
  return (
    <Icon className={classnames(logo, className)} {...other}>
      ÷
    </Icon>
  );
};

export default Logo;
